/* 7-14: PDP メディアギャラリー（Q44＋0713-#23 統合仕様・DECISIONS 2026-08-03 ADR）。
 *
 * 責務（commerce には一切干渉しない・tol-pdp-form.js から gallery/動画モーダルを移設して独立）:
 *  1) メインスライダー: 全 media を横並び track（CSS scroll-snap）で 1 枚ずつ表示。
 *     SP = ネイティブスワイプ（この JS は関与しない・pointerType mouse 限定）。
 *     PC = grab ドラッグ（|dx|>5px 確定・rAF 一段予約・ドラッグ中は .is-dragging で snap 停止 →
 *     リリースで着地先へ自前 rAF アニメ（320ms ease-out）→ 完了後に snap 復帰＝原本 0713 シート
 *     L507 指定。着地先 = 最寄り＋「開始スライドから 20% 以上で隣へ進む」方向しきい値）。
 *  2) サムネ連動: タップで該当スライドへ移動（動画サムネも同じ＝直モーダル廃止）・
 *     スクロール位置から現在スライドを検知して is-active / aria-current を同期。
 *  3) 拡大モーダル: 画像スライド全面ボタンのタップで起動（Q44 A 提案フロー・モーダル内送りなし）。
 *  4) 動画: ★2026-10 でポップアップ（モーダル）をやめ、その場再生に変えた（ユーザー裁定・0713-#23 の
 *     「▶→既存の動画モーダル」を supersede）。動画スライド中央の▶ → スライドの上に動画を重ねて再生。
 *     <product-info> 外の CTA（商品説明 Body 内の動画 / item.video・0713-#22）も document 委譲で
 *     [data-tol-video-host] の中にその場で差し込む（ポスター付きボタンは隠す）。中身は従来どおり <template>。
 *     同時に鳴らさない＝1 本再生したら他は止める。スライドを移ったら、そのスライドの動画は外して▶に戻す。
 *     ★スライド内で再生中の YouTube は指の操作を iframe が受け取る＝動画の上ではスワイプできない（サムネで移動）。
 *     initVideoModal はモーダル DOM と Escape 等の後始末のため残す（呼び出し元は無い）。
 *     ★2026-10 追補: 商品説明・添付欄の動画は、画面に入ったらミュートで自動再生する（initPdp の IntersectionObserver）。
 *  5) variant 連動（2026-10）: variant を切り替えたら、その variant の画像（featured_media）のスライドへ
 *     移動する（Dawn の PUB_SUB_EVENTS.variantChange を購読して goTo・initGallery 末尾）。
 *  6) サムネのスライダー化（2026-10）: サムネは折返しタイルでなく 1 行の横スクロール（CSS は tol-pdp-main.css 末尾）。
 *     ここでは ①表示中スライドのサムネが見える位置へサムネ列を送る ②はみ出すときだけ PC 用の ‹ › ボタンを出す。
 *
 * ★ ドラッグ状態機械の不変条件（critical H-1 / Codex BLOCKER・二系統一致）:
 *  - confirmed drag 成立以後のあらゆる退出（pointerup moved/unmoved・pointercancel・
 *    lostpointercapture・settle 破棄後の未確定 pointerup）は必ず land()（着地＋settle）へ合流して
 *    .is-dragging を除去する。収束しない退出が 1 つでも残ると snap 停止＋子 pointer-events:none が
 *    恒久残留し「スナップ死＋ボタン全滅」になる。
 *  - 着地アニメの完了系 callback（rAF step / 保険 setTimeout）は単調増加のセッショントークンを
 *    確認してから作用する（G6 psheet closeSession と同型）。破棄トリガー = 新 pointerdown・wheel・
 *    サムネ goTo・visibilitychange(hidden)・teardown。stale callback が snap 点外で class を外すと
 *    再 snap ジャンプ（原本 L507 の名指し症状）になるため。
 *  - 着地は native smooth scrollTo でなく自前 rAF アニメ（land() 内コメント参照）。保険 timeout は
 *    setTimeout（rAF カウント禁止＝タブ非表示で rAF が止まり永久不発火）。
 *
 * ★ is-dragging を「即時」でなく着地完了後に外す理由: snap 再有効化はブラウザが即 re-snap する＝
 *   進行中のアニメーションと競合して瞬間ジャンプする。完了後なら位置が snap 点上で無害。
 *
 * ★ Dawn 機構との分離（S19b 決定1 と同じ規律）: <media-gallery> / slider-component は使わない。
 *   product-info.js updateMedia は media-gallery ul 不在で optional chaining の素通し（セクション側コメント参照）。
 *   ★ 2026-10: 旧「variant 切替の media 連動は意図的に無し」を撤回。updateMedia には頼らず、
 *     variantChange の通知をこのギャラリーが自分で受けて該当スライドへ goTo する（責務 5）。
 *
 * 規律（tol-pdp-form.js 前例）: custom element 作らない・アロー IIFE + window ガード +
 *  data-tol-gallery-init ガード + AbortController teardown（pdp._tolGallery に集約）+
 *  shopify:section:load/unload + pageshow(persisted) 巻き戻し。
 */
(() => {
  if (window.__tolPdpGalleryLoaded) return;
  window.__tolPdpGalleryLoaded = true;

  /* ---- 動画モーダル（tol-pdp-form.js initVideoModal の移設・open/close 契約不変） ----
   * isOtherOpen: 拡大モーダルとの body.overflow-hidden 共有対策＝もう一方が開いたままなら
   * class を残す（refcount 不整合の早期解除を防ぐ・Codex MEDIUM）。 */
  const initVideoModal = (scope, signal, isOtherOpen) => {
    const modal = scope.querySelector('[data-tol-video-modal]');
    if (!modal) return { open: () => {}, close: () => {}, isOpen: () => false };
    const body = modal.querySelector('[data-tol-video-body]');
    const panel = modal.querySelector('.tol-main-product__video-panel');
    const closeEls = Array.from(modal.querySelectorAll('[data-tol-video-close]'));
    /* trapFocus へは focusable な ✕ button を渡す（closeEls[0] は overlay div ＝ focus() が
     * 無言で不発でフォーカスが opener に残留する・移設時の是正・DEV 実測） */
    const closeBtn = closeEls.find((el) => el.tagName === 'BUTTON') || closeEls[0];
    let opener = null;

    const isOpen = () => !modal.hasAttribute('hidden');

    const open = (tpl, trigger) => {
      if (!tpl || !body) return;
      opener = trigger || null;
      /* template の中身（iframe / video）を複製して挿入 */
      const content = tpl.content ? tpl.content.cloneNode(true) : null;
      if (content) {
        body.replaceChildren(content);
      }
      modal.removeAttribute('hidden');
      document.body.classList.add('overflow-hidden');
      if (typeof trapFocus === 'function') {
        trapFocus(panel || modal, closeBtn);
      } else if (closeBtn) {
        closeBtn.focus();
      }
    };

    const close = () => {
      if (!isOpen()) return;
      modal.setAttribute('hidden', '');
      if (!isOtherOpen()) document.body.classList.remove('overflow-hidden');
      /* 動画 DOM を破棄して再生停止（iframe / video を消す） */
      if (body) body.replaceChildren();
      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus(opener);
      } else if (opener) {
        opener.focus();
      }
      opener = null;
    };

    closeEls.forEach((el) => el.addEventListener('click', close, { signal }));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close(); /* 閉時は isOpen ガードで no-op＝拡大側と干渉しない */
    }, { signal });

    return { open, close, isOpen };
  };

  /* ---- 拡大モーダル（Q44 新設・動画モーダル同型・表示中スライドの画像 1 枚を大きく見せる最小実装） ---- */
  const initZoomModal = (scope, signal, isOtherOpen) => {
    const modal = scope.querySelector('[data-tol-zoom-modal]');
    if (!modal) return { open: () => {}, close: () => {}, isOpen: () => false };
    const img = modal.querySelector('[data-tol-zoom-img]');
    const panel = modal.querySelector('.tol-main-product__zoom-panel');
    const closeEls = Array.from(modal.querySelectorAll('[data-tol-zoom-close]'));
    const closeBtn = closeEls.find((el) => el.tagName === 'BUTTON') || closeEls[0];
    let opener = null;

    const isOpen = () => !modal.hasAttribute('hidden');

    const open = (btn) => {
      if (!btn || !img) return;
      opener = btn;
      img.src = btn.dataset.zoomSrc || '';
      img.alt = btn.dataset.alt || '';
      /* aspect-ratio をロード前に確定してモーダル内のロード時シフトを抑える */
      if (btn.dataset.zoomRatio) img.style.aspectRatio = btn.dataset.zoomRatio;
      else img.style.removeProperty('aspect-ratio');
      modal.removeAttribute('hidden');
      document.body.classList.add('overflow-hidden');
      if (typeof trapFocus === 'function') {
        trapFocus(panel || modal, closeBtn);
      } else if (closeBtn) {
        closeBtn.focus();
      }
    };

    const close = () => {
      if (!isOpen()) return;
      modal.setAttribute('hidden', '');
      if (!isOtherOpen()) document.body.classList.remove('overflow-hidden');
      img.removeAttribute('src'); /* stale 画像の次回開時フラッシュ防止 */
      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus(opener);
      } else if (opener) {
        opener.focus();
      }
      opener = null;
    };

    closeEls.forEach((el) => el.addEventListener('click', close, { signal }));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    }, { signal });

    return { open, close, isOpen };
  };

  /* ---- その場再生（2026-10・責務 4）----
   * host（スライド or [data-tol-video-host]）の中に <template> の中身を複製して差し込む。
   * overlay=true はスライドの上に全面で重ねる（スライドは寸法固定）。false は host の中に 16:9 で置く（ボタンは CSS で隠す）。
   * iframe は autoplay=1 を足し allow に autoplay を含める（▶ を押した操作のあとなので多くの環境で即再生。
   * iOS など自動再生できない環境では動画側の再生ボタンをもう一度押す）。video は play()（失敗は握りつぶす）。
   * 止める＝差し込んだ DOM を消す（iframe/video ごと破棄して音も止まる・旧モーダルの close と同じ考え方）。
   * ★ 2026-10 opts.auto（画面に入ったときの自動再生・initPdp の IntersectionObserver）:
   *   ・ミュートで始める（ブラウザはミュートなら操作なしの自動再生を許す。iOS も playsinline＋muted で可）。
   *     YouTube は mute=1＆playsinline=1、Vimeo は muted=1 を足す（他のサービスには両方を足す＝知らない引数は無視される）。
   *   ・ほかの再生中の動画は止めない（自動再生が、お客様が自分で再生した動画を止めないように）。
   *   ・フォーカスを動かさない（スクロール中に動画へフォーカスが飛ぶとページが跳ねる・操作の位置も奪う）。 */
  const inlineHosts = new Set();
  const stopInline = (host) => {
    if (!host) return;
    const box = host.querySelector(':scope > [data-tol-video-inline]');
    if (box) box.remove();
    host.classList.remove('is-playing');
    inlineHosts.delete(host);
  };
  const stopAllInline = (except) => {
    Array.from(inlineHosts).forEach((h) => {
      if (h !== except) stopInline(h);
    });
  };
  const playInline = (host, tpl, overlay, opts) => {
    if (!host || !tpl || !tpl.content) return;
    if (host.querySelector(':scope > [data-tol-video-inline]')) return; /* 再生中なら何もしない */
    const auto = !!(opts && opts.auto);
    if (!auto) stopAllInline(host); /* 同時に鳴らさない（手で再生したときだけ。自動再生はミュートなので止めない） */
    const box = document.createElement('div');
    box.className = 'tol-video-inline' + (overlay ? ' tol-video-inline--overlay' : '');
    box.setAttribute('data-tol-video-inline', '');
    box.appendChild(tpl.content.cloneNode(true));
    const iframe = box.querySelector('iframe');
    if (iframe) {
      const src = iframe.getAttribute('src') || '';
      let add = [];
      if (src && !/[?&]autoplay=/.test(src)) add.push('autoplay=1');
      if (src && auto) {
        if (/youtube(-nocookie)?\.com|youtu\.be/.test(src)) add = add.concat(['mute=1', 'playsinline=1']);
        else if (/vimeo\.com/.test(src)) add.push('muted=1');
        else add = add.concat(['mute=1', 'muted=1']);
      }
      if (add.length) iframe.setAttribute('src', src + (src.indexOf('?') === -1 ? '?' : '&') + add.join('&'));
      const allow = iframe.getAttribute('allow') || '';
      if (!/autoplay/.test(allow)) iframe.setAttribute('allow', (allow ? allow + '; ' : '') + 'autoplay');
      iframe.removeAttribute('loading'); /* 表示中なので遅延させない */
    }
    host.appendChild(box);
    host.classList.add('is-playing');
    inlineHosts.add(host);
    const video = box.querySelector('video');
    const focusTarget = video || iframe;
    if (video) {
      video.setAttribute('playsinline', '');
      if (auto) {
        video.muted = true; /* play() より前に（ミュートでないと自動再生が拒否される） */
        video.setAttribute('muted', '');
      }
      try {
        const p = video.play();
        if (p && typeof p.catch === 'function') p.catch(() => {});
      } catch (_) { /* 自動再生不可＝利用者が動画の再生ボタンを押す */ }
    }
    /* 押したボタンは隠れるので、フォーカスを動画へ移す（キーボード操作の行き場を失わない）。自動再生では動かさない */
    if (!auto && focusTarget && typeof focusTarget.focus === 'function') {
      try { focusTarget.focus({ preventScroll: true }); } catch (_) { focusTarget.focus(); }
    }
  };

  /* ---- ギャラリー（スライダー・ドラッグ・index 検知・サムネ連動） ---- */

  const initGallery = (scope, signal, openVideo, openZoom) => {
    const gallery = scope.querySelector('[data-tol-gallery]');
    if (!gallery) return null;
    const track = gallery.querySelector('[data-tol-gallery-track]');
    if (!track) return null; /* media 0 件 = placeholder（全機能スキップ・fail-safe） */
    const slides = Array.from(track.querySelectorAll('[data-tol-gallery-slide]'));
    if (!slides.length) return null;
    const thumbs = Array.from(gallery.querySelectorAll('[data-tol-gallery-thumb]'));
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    /* 現在スライド index = 各 slide.offsetLeft との最近傍（goTo/着地と座標基準を単一化・
     * clientWidth 除算はズーム/サブピクセル累積で offsetLeft 基準と乖離しうる） */
    const indexNow = () => {
      const x = track.scrollLeft;
      let best = 0;
      let bestD = Infinity;
      for (let i = 0; i < slides.length; i++) {
        const d = Math.abs(slides[i].offsetLeft - x);
        if (d < bestD) {
          bestD = d;
          best = i;
        }
      }
      return best;
    };

    /* 隣接スライドの img を先読み eager 化（スワイプ先の lazy 白フラッシュ緩和） */
    const warmup = (i) => {
      [i - 1, i + 1].forEach((j) => {
        const s = slides[j];
        if (!s) return;
        const img = s.querySelector('img[loading="lazy"]');
        if (img) img.loading = 'eager';
      });
    };

    /* ★ 2026-10（責務 6）: サムネ列 = 1 行の横スクロール。ボタン（‹ ›）は JS で足す（はみ出すときだけ・PC だけ CSS で見せる）。
       ul を div.tol-main-product__thumbs-wrap で包む（ボタンの位置の基準）。サムネが無い（media 1 枚）なら何もしない。
       ボタンの送り幅 = 見えている幅の 8 割（端の 1 枚を残して次へ）。スクロール位置は scroll-snap が整える。 */
    const thumbList = gallery.querySelector('[data-tol-gallery-thumbs]');
    const thumbBehavior = () => (reduced.matches ? 'auto' : 'smooth');
    if (thumbList && thumbs.length > 1) {
      const wrap = document.createElement('div');
      wrap.className = 'tol-main-product__thumbs-wrap';
      thumbList.parentNode.insertBefore(wrap, thumbList);
      wrap.appendChild(thumbList);
      const makeNav = (dir) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'tol-main-product__thumbs-nav tol-main-product__thumbs-nav--' + dir;
        b.setAttribute('aria-label', dir === 'prev' ? '前の画像を表示' : '次の画像を表示');
        b.innerHTML =
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="' +
          (dir === 'prev' ? 'M15 6l-6 6 6 6' : 'M9 6l6 6-6 6') +
          '"/></svg>';
        b.addEventListener('click', () => {
          /* 送り先はサムネ 1 枚の左端にそろえ、0〜最大の範囲に収めて scrollTo する（2026-10 修正）。
             旧: scrollBy(±見えている幅の 8 割) は端を越える量を渡すことがあり、iOS Safari では scroll-snap と
             smooth の組み合わせで端を越えて引っ張られ、左端に大きな余白が出たまま止まることがあった（ユーザー実機）。
             送る枚数 = 見えている枚数の 8 割（最低 1 枚）。 */
          const items = Array.from(thumbList.children);
          if (!items.length) return;
          const base = items[0].offsetLeft;
          const max = Math.max(0, thumbList.scrollWidth - thumbList.clientWidth);
          const cur = thumbList.scrollLeft;
          let first = 0; /* 今いちばん左に（少しでも）見えている 1 枚 */
          for (let i = 0; i < items.length; i++) {
            if (items[i].offsetLeft - base + items[i].offsetWidth > cur + 1) {
              first = i;
              break;
            }
          }
          const step = items.length > 1 ? (items[1].offsetLeft - items[0].offsetLeft) : items[0].offsetWidth;
          const perView = Math.max(1, Math.floor((thumbList.clientWidth + 1) / (step || 1)));
          const move = Math.max(1, Math.floor(perView * 0.8));
          const target = Math.max(0, Math.min(items.length - 1, first + (dir === 'prev' ? -move : move)));
          const left = Math.max(0, Math.min(max, items[target].offsetLeft - base));
          thumbList.scrollTo({ left: left, behavior: thumbBehavior() });
        }, { signal });
        wrap.appendChild(b);
        return b;
      };
      const prevBtn = makeNav('prev');
      const nextBtn = makeNav('next');
      const updateNav = () => {
        const max = thumbList.scrollWidth - thumbList.clientWidth;
        const over = max > 1;
        wrap.classList.toggle('is-overflowing', over);
        prevBtn.disabled = !over || thumbList.scrollLeft <= 1;
        nextBtn.disabled = !over || thumbList.scrollLeft >= max - 1;
      };
      thumbList.addEventListener('scroll', updateNav, { passive: true, signal });
      window.addEventListener('resize', updateNav, { signal });
      updateNav();
    }
    /* 表示中スライドのサムネがサムネ列の外にいたら、見える位置までサムネ列だけを送る
       （scrollIntoView はページごと縦に動かしうるので使わない＝サムネ列の scrollLeft だけを動かす） */
    const keepThumbVisible = (thumb) => {
      if (!thumbList || !thumb) return;
      const item = thumb.parentElement || thumb;
      const lr = thumbList.getBoundingClientRect();
      const ir = item.getBoundingClientRect();
      if (ir.left < lr.left) thumbList.scrollBy({ left: ir.left - lr.left, behavior: thumbBehavior() });
      else if (ir.right > lr.right) thumbList.scrollBy({ left: ir.right - lr.right, behavior: thumbBehavior() });
    };

    /* サムネ active / aria-current 同期（data-media-id 突合＝位置 index に依存しない） */
    let lastIndex = -1;
    const setActive = (i) => {
      if (i === lastIndex) return;
      lastIndex = i;
      warmup(i);
      /* 2026-10（責務 4）: 別のスライドへ移ったら、再生中の動画は外して▶に戻す（裏で鳴り続けない） */
      slides.forEach((s, j) => {
        if (j !== i && s.classList.contains('is-playing')) stopInline(s);
      });
      const id = slides[i] ? slides[i].dataset.mediaId : '';
      if (!id) return;
      thumbs.forEach((t) => {
        const on = t.dataset.mediaId === id;
        t.classList.toggle('is-active', on);
        if (on) {
          t.setAttribute('aria-current', 'true');
          keepThumbVisible(t); /* 2026-10（責務 6）: スワイプ・variant 切替でもサムネ列が追従する */
        } else t.removeAttribute('aria-current');
      });
    };

    /* スライド内ボタンの配線（zoom / 再生）。media 1 枚でも配線する（Q44 は枚数に依らない） */
    slides.forEach((slide) => {
      const zoomBtn = slide.querySelector('[data-tol-zoom-open]');
      if (zoomBtn) {
        zoomBtn.addEventListener('click', () => openZoom(zoomBtn), { signal });
      }
      const playBtn = slide.querySelector('[data-tol-slide-play]');
      if (playBtn) {
        playBtn.addEventListener('click', () => {
          /* 2026-10: モーダルでなくスライドの上でその場再生（責務 4） */
          playInline(slide, slide.querySelector('[data-tol-video-html]'), true);
        }, { signal });
      }
    });

    /* 初期 active（aria-current を初回スクロール前から供給）＋2 枚目の warm-up */
    setActive(indexNow());

    /* ここから下はスライダー機構（media 1 枚では不要＝ドラッグ/scroll 監視をスキップ） */
    if (slides.length < 2) return null;

    /* ---- settle（着地）: セッショントークンで stale callback を無害化 ---- */
    const settle = { session: 0, timer: 0, raf: 0 };

    const cancelSettle = () => {
      settle.session++;
      if (settle.timer) {
        clearTimeout(settle.timer);
        settle.timer = 0;
      }
      if (settle.raf) {
        cancelAnimationFrame(settle.raf);
        settle.raf = 0;
      }
    };

    /* 着地: .is-dragging を除去する唯一の経路（不変条件）。snap 停止中に自前 rAF アニメーション
     * （固定 320ms・easeOutCubic）で目標 snap 点へ寄せ、完了後に snap を復帰する。
     * native smooth scrollTo を使わない理由（ユーザー実機フィードバック 2026-08-03）:
     * ①所要時間が距離比例のため短距離リリースで「ぱっと」跳ねて見える（固定時間＋ease-out で
     *   意図した滑らかさにする）②進行中の smooth は instant scrollTo で同一フレーム内に中断し
     *   切れない Chrome 挙動（DEV 単離プローブ実測）との競合管理〔scrollend/ポール/再補正ループ〕
     *   が丸ごと不要になる（自前で scrollLeft を書くだけ＝決定的）。 */
    const land = (i) => {
      cancelSettle();
      const session = settle.session;
      const idx = Math.max(0, Math.min(i, slides.length - 1));
      const target = slides[idx].offsetLeft;

      const finishNow = () => {
        if (session !== settle.session) return; /* stale（新ドラッグ/goTo/wheel が所有権を持つ） */
        cancelSettle();
        track.scrollLeft = target;
        track.classList.remove('is-dragging');
        setActive(indexNow());
      };

      const from = track.scrollLeft;
      const dist = target - from;
      if (reduced.matches || Math.abs(dist) < 1) {
        finishNow();
        return;
      }
      const DURATION = 320;
      const start = performance.now();
      const ease = (p) => 1 - Math.pow(1 - p, 3); /* easeOutCubic */
      const step = (now) => {
        if (session !== settle.session) return;
        const p = Math.min(1, (now - start) / DURATION);
        track.scrollLeft = from + dist * ease(p);
        if (p < 1) {
          settle.raf = requestAnimationFrame(step);
          return;
        }
        settle.raf = 0;
        finishNow();
      };
      settle.raf = requestAnimationFrame(step);
      /* rAF 凍結（タブ非表示等）の保険＝setTimeout で必ず収束（通常完了時は cancelSettle 済みで no-op） */
      settle.timer = setTimeout(finishNow, DURATION + 400);
    };

    /* サムネ→該当スライド。is-dragging 中（settle 進行中のサムネ click）は land に合流して
     * 所有権を引き継ぐ。非ドラッグ時は snap 有効のまま snap 点へ smooth（ジャンプ要素なし） */
    const goTo = (i) => {
      if (track.classList.contains('is-dragging')) {
        land(i);
        return;
      }
      const idx = Math.max(0, Math.min(i, slides.length - 1));
      track.scrollTo({
        left: slides[idx].offsetLeft,
        behavior: reduced.matches ? 'auto' : 'smooth',
      });
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const id = thumb.dataset.mediaId;
        const i = slides.findIndex((s) => s.dataset.mediaId === id);
        if (i >= 0) goTo(i); /* 動画サムネも同じ＝動画スライドへ移動（直モーダル廃止・0713-#23） */
      }, { signal });
    });

    /* ---- scroll → active 同期（rAF 一段スロットル・ドラッグ/慣性中もサムネが追従） ---- */
    let scrollRaf = 0;
    track.addEventListener('scroll', () => {
      if (scrollRaf) return;
      scrollRaf = requestAnimationFrame(() => {
        scrollRaf = 0;
        setActive(indexNow());
      });
    }, { passive: true, signal });

    /* ---- PC grab ドラッグ状態機械（tol-slider L166-300 のパターン踏襲＋snap 制御） ---- */
    const drag = { active: false, confirmed: false, pointerId: null, startX: 0, startScroll: 0, startIdx: 0, raf: 0, target: 0 };
    let clickSuppress = false;

    /* 着地先の選定: 基本は最寄り。ただし開始スライドからスライド幅の 20% 以上引っ張って離した
     * ときはその方向の隣へ進める（「少し引っ張って離す→次へ」の一般的なカルーセルの手応え・
     * ユーザー実機フィードバック 2026-08-03。snap-stop always と同じく一度に 1 枚まで） */
    const pickLandingIndex = () => {
      const iNear = indexNow();
      const startIdx = drag.startIdx;
      if (iNear !== startIdx) return iNear; /* 半分以上動いた＝最寄りをそのまま採用 */
      const w = track.clientWidth || 1;
      const delta = track.scrollLeft - slides[startIdx].offsetLeft;
      if (delta > w * 0.2 && startIdx < slides.length - 1) return startIdx + 1;
      if (delta < -w * 0.2 && startIdx > 0) return startIdx - 1;
      return startIdx;
    };

    /* 即時静止: ドラッグ/settle を破棄し最寄り snap 点へ auto 着地して is-dragging を外す
     * （visibilitychange(hidden)・pageshow(persisted)・teardown の収束経路） */
    const forceRest = () => {
      if (drag.raf) {
        cancelAnimationFrame(drag.raf);
        drag.raf = 0;
      }
      if (scrollRaf) {
        cancelAnimationFrame(scrollRaf);
        scrollRaf = 0;
      }
      drag.active = false;
      drag.confirmed = false;
      drag.pointerId = null;
      cancelSettle();
      if (track.classList.contains('is-dragging')) {
        track.scrollTo({ left: slides[indexNow()].offsetLeft, behavior: 'auto' });
        track.classList.remove('is-dragging');
        setActive(indexNow());
      }
    };

    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (drag.active) return;
      /* 着地（settle）進行中の再ドラッグ: 監視を破棄し is-dragging 維持のまま新ドラッグが所有。
       * threshold は再適用しない（確定済みから開始）＝未確定のまま離しても endDrag が land へ収束 */
      const inherited = track.classList.contains('is-dragging');
      cancelSettle();
      drag.active = true;
      drag.confirmed = inherited;
      drag.pointerId = e.pointerId;
      drag.startX = e.clientX;
      drag.startScroll = track.scrollLeft;
      drag.startIdx = indexNow(); /* 20% しきい値の基準スライド（着地中の再ドラッグは現在最寄り） */
      if (inherited) {
        try { track.setPointerCapture(e.pointerId); } catch (_) { /* 劣化受容 */ }
      }
      /* preventDefault しない（|dx|≦5px の通常 click＝拡大/再生を生かす） */
    }, { signal });

    const onMove = (e) => {
      if (!drag.active || e.pointerId !== drag.pointerId) return;
      /* ボタン非押下の move = pointerup を取りこぼした残留状態（未確定でウィンドウ外リリース等）。
       * hover 移動を誤ってドラッグ確定させないよう即収束（critical L-1） */
      if (e.buttons === 0) {
        endDrag(e, false);
        return;
      }
      const dx = e.clientX - drag.startX;
      if (!drag.confirmed) {
        if (Math.abs(dx) <= 5) return;
        drag.confirmed = true;
        track.classList.add('is-dragging'); /* CSS: snap 停止・grabbing・子 pointer-events:none */
        try { track.setPointerCapture(drag.pointerId); } catch (_) { /* 劣化受容 */ }
      }
      drag.target = drag.startScroll - dx;
      if (!drag.raf) {
        drag.raf = requestAnimationFrame(() => {
          drag.raf = 0;
          track.scrollLeft = drag.target; /* rAF 一段予約＝カーソルに滑らか追従（原本 L507） */
        });
      }
    };

    /* 退出の唯一の合流点: confirmed（is-dragging 保持）なら必ず land へ。
     * flush=true（正常 pointerup）は保留 rAF を同期反映してから着地距離を確定する。 */
    const endDrag = (e, flush) => {
      if (!drag.active) return;
      if (e && e.pointerId != null && e.pointerId !== drag.pointerId) return;
      const confirmed = drag.confirmed || track.classList.contains('is-dragging');
      if (drag.raf) {
        cancelAnimationFrame(drag.raf);
        drag.raf = 0;
        if (flush && drag.confirmed) track.scrollLeft = drag.target;
      }
      drag.active = false;
      drag.confirmed = false;
      drag.pointerId = null;
      if (confirmed) {
        /* ドラッグ後の click（zoom/▶）誤発火を capture 段で 1 回だけ抑止 */
        clickSuppress = true;
        setTimeout(() => { clickSuppress = false; }, 0);
        land(pickLandingIndex());
      }
    };

    /* 確定前にトラック外へ出ても取りこぼさないよう window で購読（tol-slider 同型） */
    window.addEventListener('pointermove', onMove, { signal });
    window.addEventListener('pointerup', (e) => endDrag(e, true), { signal });
    window.addEventListener('pointercancel', (e) => endDrag(e, false), { signal });
    track.addEventListener('lostpointercapture', (e) => endDrag(e, false), { signal });

    /* img / button のネイティブ drag が pointer stream を殺すのを防ぐ（tol-slider 前例どおり
     * 操作中のみ抑止＝押下起点でない dragstart は生かす） */
    track.addEventListener('dragstart', (e) => {
      if (drag.active) e.preventDefault();
    }, { signal });

    /* capture 段はターゲット段（zoom/▶ハンドラー）より先に走る＝抑止が確実に効く */
    track.addEventListener('click', (e) => {
      if (!clickSuppress) return;
      e.preventDefault();
      e.stopPropagation();
    }, { capture: true, signal });

    /* settle 進行中の wheel/トラックパッド横パン: ユーザーへ主導権を返す＝監視破棄・即時 snap 復帰
     * （native の wheel＋snap 機構に委譲。stale callback がユーザー操作中の位置で class を外す
     * 競合を先回りで消す）。ドラッグ操作中（drag.active）はドラッグが所有するため対象外 */
    track.addEventListener('wheel', () => {
      if (drag.active) return;
      if (!track.classList.contains('is-dragging')) return;
      cancelSettle();
      track.classList.remove('is-dragging');
      setActive(indexNow());
    }, { passive: true, signal });

    /* タブ非表示: rAF 凍結・timeout 誤発火の芽を摘む＝即時静止で収束 */
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') forceRest();
    }, { signal });

    /* ★ 2026-10（責務 5）: variant 切替で、その variant の画像（featured_media）のスライドへ移動する。
     * Dawn の product-info.js は切替のたびに PUB_SUB_EVENTS.variantChange（data: { sectionId, html, variant }）を
     * publish する。<media-gallery> 向けの updateMedia はこのギャラリーでは空振りするので、ここで受けて goTo する
     * （サムネ click と同じ移動＝ドラッグ着地中なら land に合流・サムネの active は scroll 同期が追従）。
     * variant に画像が無い・ギャラリーに該当スライドが無い・既にそのスライドにいるときは何もしない。
     * 同じページに PDP が 2 つあっても自分のセクションの通知だけを拾う（sectionId 突合・product-info.js は
     * dataset.originalSection || dataset.section を載せる＝tol- の PDP は data-section のみ）。
     * pubsub.js 不在（subscribe 未定義）なら購読しない＝従来どおり切り替わらないだけ（fail-safe）。
     * teardown は AbortController の signal に相乗り（abort で購読解除）。
     * 対象は media 2 枚以上の商品（1 枚は上の early return で到達しない＝切り替える先が無い）。 */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      const sectionId = scope.dataset.section;
      const unsubVariant = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const d = event && event.data;
        if (!d || (sectionId && d.sectionId !== sectionId)) return;
        const media = d.variant && d.variant.featured_media;
        if (!media || media.id == null) return;
        const i = slides.findIndex((s) => s.dataset.mediaId === String(media.id));
        if (i >= 0 && i !== indexNow()) goTo(i);
      });
      if (typeof unsubVariant === 'function') signal.addEventListener('abort', unsubVariant);
    }

    return { forceRest };
  };

  /* ---- 起動（tol-pdp-form.js と独立・実行順依存なし） ---- */

  const initPdp = (pdp) => {
    if (pdp.dataset.tolGalleryInit) return;
    pdp.dataset.tolGalleryInit = 'true';
    const scope = pdp; /* product-info 要素自身がスコープ */
    const abort = new AbortController();
    const signal = abort.signal;

    /* 相互参照は遅延評価（open/close 時に評価される closure）＝初期化順の循環なし */
    const modals = {};
    modals.video = initVideoModal(scope, signal, () => modals.zoom.isOpen());
    modals.zoom = initZoomModal(scope, signal, () => modals.video.isOpen());

    const gallery = initGallery(scope, signal, modals.video.open, modals.zoom.open);

    /* 0713-#22: <product-info> の外にある再生ボタン（tol-product-body の A系 CTA /
     * tol-pdp-attachments の B系 CTA・共通 snippet tol-video-embed）→ 既存の動画モーダルへ委譲。
     * モーダル DOM は 1 つのまま＝7-14 の data 契約（open(tpl, trigger) / close で動画 DOM 破棄）は不変。
     * document 委譲にする理由: 対象はこのセクションの外の独立セクションで、テーマエディターで
     * 個別に再描画されるため要素直付けでは配線が失われる（#11 で clone 置換の実効を確認した教訓）。
     * teardown は既存 AbortController に相乗り（signal）。既存のスライド配線とは別属性で衝突しない。 */
    document.addEventListener(
      'click',
      (e) => {
        const t = e.target;
        if (!t || !t.closest) return;
        const btn = t.closest('[data-tol-video-open]');
        if (!btn) return;
        /* 所有者の決定（二系統レビュー 2026-08-04）: 委譲は [data-tol-pdp] ごとに 1 本登録されるため、
         * 万一 1 ページに PDP セクションが 2 つ置かれた場合（両セクションに preset があり構成上は可能）に
         * 1 クリックで両方のモーダルが開いてしまう。CTA を包む pdp（無ければ文書内の先頭 pdp）だけが
         * 処理する＝通常の 1 セクション構成では挙動不変。 */
        const owner = btn.closest('[data-tol-pdp]') || document.querySelector('[data-tol-pdp]');
        if (owner !== pdp) return;
        const host = btn.closest('[data-tol-video-host]');
        const tpl = host && host.querySelector('[data-tol-video-html]');
        /* 2026-10（責務 4）: モーダルでなく host の中でその場再生（tpl が無ければ何もしない＝fail-safe） */
        if (tpl) playInline(host, tpl, false);
      },
      { signal }
    );

    /* ★ 2026-10: 商品説明・添付欄の動画（[data-tol-video-host]）は、画面に半分以上入ったらミュートで自動再生する。
     * 1 本につき 1 回だけ（始めたら監視をやめる＝画面外へ出ても止めない・戻ってきても最初からやり直さない）。
     * 動きを減らす設定（prefers-reduced-motion）・データ節約モード（Save-Data）のお客様には自動再生しない（従来どおり▶で再生）。
     * 所有者の決定は上の click 委譲と同じ（CTA を包む pdp・無ければ文書内の先頭 pdp）。
     * ギャラリー（商品画像スライダー）の動画スライドは対象外＝画像スライドと並ぶので自動では動かさない（▶で再生）。 */
    const autoOk =
      typeof IntersectionObserver !== 'undefined' &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches &&
      !(navigator.connection && navigator.connection.saveData);
    if (autoOk) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (!en.isIntersecting) return;
          const host = en.target;
          io.unobserve(host);
          if (host.classList.contains('is-playing')) return;
          const tpl = host.querySelector('[data-tol-video-html]');
          if (tpl) playInline(host, tpl, false, { auto: true });
        });
      }, { threshold: 0.5 });
      document.querySelectorAll('[data-tol-video-host]').forEach((host) => {
        const owner = host.closest('[data-tol-pdp]') || document.querySelector('[data-tol-pdp]');
        if (owner === pdp) io.observe(host);
      });
      signal.addEventListener('abort', () => io.disconnect());
    }

    /* bfcache 復元の巻き戻し（js-navigation-does-not-cancel-pending-timers の教訓）:
     * is-dragging（snap 停止）と body.overflow-hidden の snapshot 残留を解除する。
     * track の scroll 位置はブラウザが復元 → scroll イベントで active が自己同期 */
    window.addEventListener('pageshow', (e) => {
      if (!e.persisted) return;
      if (gallery) gallery.forceRest();
      modals.video.close();
      modals.zoom.close();
      stopAllInline(); /* 2026-10: bfcache 復元で再生中の動画を残さない */
    }, { signal });

    /* teardown 所有権の集約（_tolPdp/_tolPsheet と同パターン・個別プロパティは作らない） */
    pdp._tolGallery = {
      abort,
      closeVideo: modals.video.close,
      closeZoom: modals.zoom.close,
      forceRest: gallery ? gallery.forceRest : () => {},
    };
  };

  const init = (root) => {
    const pdps = Array.from(root.querySelectorAll('[data-tol-pdp]'));
    if (root.matches && root.matches('[data-tol-pdp]')) pdps.push(root);
    pdps.forEach(initPdp);
  };

  init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:unload', (e) => {
    e.target.querySelectorAll('[data-tol-pdp]').forEach((pdp) => {
      if (pdp._tolGallery) {
        pdp._tolGallery.closeVideo(); /* 開いたまま破棄で body class / trapFocus 残留を防ぐ */
        stopAllInline(); /* 2026-10: その場再生中の動画も止める */
        pdp._tolGallery.closeZoom();
        pdp._tolGallery.forceRest();
        pdp._tolGallery.abort.abort();
      }
    });
  });
})();